import { fetchData } from '@/utils/fetch'
import { queryString, toReject } from './util'

export const retrieveDropshippingUrl = toReject((data) => {
  const query = queryString(data)
  return fetchData(`/appb/b2b/product/getListedProduct?${query}`)
})
